export const HEL_AUDIO_TYPE_WORLD = 0;
export const HEL_AUDIO_TYPE_VOICE = 1;
export const HEL_AUDIO_TYPE_SE = 2;
export const HEL_AUDIO_TYPE_SYSTEMSE = 3;
export const HEL_AUDIO_TYPE_VIDEO = 4;
export type HelAudioTypeIndex =
  | typeof HEL_AUDIO_TYPE_WORLD
  | typeof HEL_AUDIO_TYPE_VOICE
  | typeof HEL_AUDIO_TYPE_SE
  | typeof HEL_AUDIO_TYPE_SYSTEMSE
  | typeof HEL_AUDIO_TYPE_VIDEO;

export const HEL_VIDEO_PLAYER_DEFAULT = 0;
export const HEL_VIDEO_PLAYER_IVS = 1;
export const HEL_VIDEO_PLAYER_HLS = 2;

export const __MEDIASTREAM__ = '__MEDIASTREAM__.mp4';

export const ETextParamType_WorldID = 0;
export const ETextParamType_RoomID = 1;
export const ETextParamType_SpotName = 2;
export const ETextParamType_LocationHref = 3;
export const ETextParamType_ShowWorldSelect = 4;
export const ETextParamType_Logined = 5;
export const ETextParamType_CanvasFileName = 6;
export const ETextParamType_CurrentUserName = 7;
export const ETextParamType_SceneItem = 8;
export const ETextParamType_OperateCanvas = 9;
export const ETextParamType_ReplaceMyAvatar = 10;
export const ETextParamType_PlayVideo = 11;
export const ETextParamType_NamePlateTextureFileName0 = 12;
export const ETextParamType_NamePlateTextureFileName1 = 13;
export const ETextParamType_NamePlateTextureFileName2 = 14;
export const ETextParamType_NamePlateMicMuteTextureFileName = 15;
export const ETextParamType_NamePlateMicOnTextureFileName = 16;
export const ETextParamType_NamePlateMicTalkingTextureFileName = 17;
export const ETextParamType_SetMicState = 18;
export const ETextParamType_OperateFunctionFlag = 19;
export const ETextParamType_CopyVideoFrameToSystem = 20;
export const ETextParamType_CancelToCopyVideoFrameToSystem = 21;
export const ETextParamType_SetMicTalkingState = 22;
export const ETextParamType_WarpPlayer = 23;
export const ETextParamType_PlayerMoveEnable = 24;
export const ETextParamType_PlayItem = 25;
export const ETextParamType_StopItem = 26;
export const ETextParamType_ShowItem = 27;
export const ETextParamType_HideItem = 28;
export const ETextParamType_ReplaceMyAvatarCustom = 29;
export const ETextParamType_SceneJson = 30;
export const ETextParamType_ScriptCallComponentMethod = 31;
export const ETextParamType_AvatarFileName = 32;
export const ETextParamType_GUIDebugInput = 33;
export const ETextParamType_HeliodorSDKVersion = 34;
export const ETextParamType_ReplaceMyAvatarIcon = 35;
export const ETextParamType_SetItemFileName = 36;
export const ETextParamType_SetFollowCameraDistance = 37;
export const ETextParamType_SetFollowCameraRotate = 38;
export const ETextParamType_SetFollowCameraHeight = 39;
export const ETextParamType_AddFurniture = 40;
export const ETextParamType_SetPlayerRotate = 41;
export const ETextParamType_PlayEmote = 42;
export const ETextParamType_GetAvatarHeight = 43;
export const ETextParamType_StopVideo = 44;
export const ETextParamType_IsPlayVideo = 45;
export const ETextParamType_ReplaceMyAvatarIconCustom = 46;
export const ETextParamType_IsLoading = 47;
export const ETextParamType_SubSceneItem = 48;
export const ETextParamType_SceneOwner = 49;
export const ETextParamType_VideoEnded = 50;
export const ETextParamType_GlobalFileName = 51;
export const ETextParamType_CheckRestriction = 52;
export const ETextParamType_ReplaceFilteredAvatar = 53;
export const ETextParamType_ClearMyAvatarCustomMotion = 54;
export const ETextParamType_CreateMyAvatarCustomMotion = 55;
export const ETextParamType_CreateMyAvatarCustomEmotion = 56;
export const ETextParamType_CreateMyAvatarCustomObject = 57;
export const ETextParamType_SetDateNow = 58;
export const ETextParamType_SetCRPMode = 59;
export const ETextParamType_SetPlayerPriority = 60;
export const ETextParamType_OnStartScreenShare = 61;
export const ETextParamType_OnStopScreenShare = 62;
export const ETextParamType_OnReceivedStartScreenShare = 63;
export const ETextParamType_OnReceivedStopScreenShare = 64;
export const ETextParamType_SetVideoRecording = 65;
export const ETextParamType_SetRoomURL = 66;
export const ETextParamType_IsUseGamePad = 67;
export const ETextParamType_ScriptCallCanvasComponentMethod = 68;
export const ETextParamType_HomeJson = 69;
export const ETextParamType_HomeJsonWithTemplate = 70;
export const ETextParamType_SetGenericWindowState = 71;
export const ETextParamType_OnChangedMicPermissionState = 72;
export const ETextParamType_IsUseMyAvatar = 73;
export const ETextParamType_OnPlayScreenShare = 74;
export const ETextParamType_CompImageListFileName = 75;
export const ETextParamType_SetItemProperty = 76;
export const ETextParamType_OnSendTextChat = 77;
export const ETextParamType_OnNetCreatedPlayerID = 78;
export const ETextParamType_OnNetPosConnected = 79;
export const ETextParamType_OnNetVoiceConnected = 80;
export const ETextParamType_GetFirstLoadingRate = 81;
export const ETextParamType_OnNetPosDisconnected = 82;
export const ETextParamType_OnNetVoiceDisconnected = 83;
export const ETextParamType_AddPackFile = 84;
export const ETextParamType_SetCDNFolderName = 85;
export const ETextParamType_OnNetLiveVideoStarted = 86;
export const ETextParamType_OnNetLiveVideoEnded = 87;
export const ETextParamType_OnNetLiveVideoPlay = 88;
export const ETextParamType_OnNetLiveVideoStop = 89;
export const ETextParamType_OnNetLiveConfirmPlayVideo = 90;
export const ETextParamType_SetWebCamTrackingPoseData = 91;
export const ETextParamType_SetWebCamTrackingHandData = 92;
export const ETextParamType_OnNetReceivePosJoin = 93;
export const ETextParamType_OnNetReceivePosLeave = 94;
export const ETextParamType_OnNetReceiveVoiceJoin = 95;
export const ETextParamType_OnNetReceiveVoiceLeave = 96;
export const ETextParamType_OnNetLiveConnected = 97;
export const ETextParamType_OnNetLiveDisconnected = 98;
export const ETextParamType_OnNetLiveRemoteJoin = 99;
export const ETextParamType_OnNetLiveRemoteLeave = 100;
export const ETextParamType_OnNetEstablishmentFail = 101;
export const ETextParamType_OnNetConnectionError = 102;
export const ETextParamType_OnNetOperationError = 103;
export const ETextParamType_IsAvailableWebCamTracking = 104;
export const ETextParamType_StartWebCamTracking = 105;
export const ETextParamType_StopWebCamTracking = 106;
export const ETextParamType_SetFullBodySendingInterval = 107;
export const ETextParamType_Supported_TextureCompression_PVRTC = 108;
export const ETextParamType_Supported_TextureCompression_ETC2 = 109;
export const ETextParamType_Supported_TextureCompression_ASTC = 110;
export const ETextParamType_Supported_TextureCompression_DXT = 111;
export const ETextParamType_SetAvatarType = 112;
export const ETextParamType_GetHeliodorSDKMajorVersion = 113;
export const ETextParamType_GetHeliodorSDKMinorVersion = 114;
export const ETextParamType_WalkTo = 115;
export const ETextParamType_SetProjectionMatrix = 116;
export const ETextParamType_OnARDetectedImage = 117;
export const ETextParamType_OnNetLobbyingUpdate = 118;
export const ETextParamType_OnARFoundWayspot = 119;
export const ETextParamType_OnCatchError = 120;
export const ETextParamType_TransitToNetworkRedicrectURL = 121;

//
export const EBinaryParamType_FullBodyTrackingData = 0;
export const EBinaryParamType_Unlink = 1;
export const EBinaryParamType_SetGUIImage = 2;

//
export const MOBILE_USER_AGENT_REGS: RegExp =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
export const IPHONE_USER_AGENT_REGS: RegExp = /iPhone|iPod/i;
export const VR_USER_AGENT_REGS: RegExp = /Quest/i;
export const IOS_VER_15 = 1500;

export const INITIAL_MIXER_SETTING = [0.2, 1.0, 0.2, 0.2, 0.2] as const;
export const INITIAL_MIXER_REAL_SETTING = [0.2, 1.0, 0.2, 0.2, 0.2] as const;
export const INITIAL_MIXER_FADER_SETTING = [1.0, 1.0, 1.0, 1.0, 1.0] as const;
export const INITIAL_MIXER_DISTANCE_SETTING = [1.0, 1.0, 1.0, 1.0, 1.0] as const;
export const INITIAL_MIXER_MUTE_SETTING = [0, 0, 0, 0, 0] as const;

export const SKYWAY_API_HOST = 'https://v1.api.vketcloud.com/';

export const CRP_VERSION = 'v2.0.0';
